import { render } from "./AchievementBanner.vue?vue&type=template&id=04e6541c&scoped=true"
import script from "./AchievementBanner.vue?vue&type=script&lang=js"
export * from "./AchievementBanner.vue?vue&type=script&lang=js"

import "./AchievementBanner.vue?vue&type=style&index=0&id=04e6541c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e6541c"]])

export default __exports__